/**
 * Link Component Styles
 */

export const linkStyles = {
  baseStyle: {
    textDecoration: 'none',
    boxShadow: 'none',
    transitionProperty: 'common',
    transitionDuration: 'fast',
    cursor: 'pointer',
    outline: 'none',
    color: 'inherit',
    // Improve focus visibility for keyboard users
    _focus: {
      boxShadow: '0 0 0 4px rgba(66,153,225,0.6)',
      outline: 'none',
    },
    _active: {
      boxShadow: 'none',
    },
    _hover: {
      textDecoration: 'none',
      border: 'none',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
      textDecoration: 'none',
    },
  },

  variants: {
    underline: {
      _hover: {
        textDecoration: 'underline',
      },
    },
    brand: {
      color: 'brand.500',
      _hover: {
        color: 'brand.600',
      },
    },
  },

  defaultProps: {},
};

export default linkStyles;
